import React from 'react';
import Spinner from './Spinner';

interface LoadingProps extends React.PropsWithChildren {
  loading: boolean;
}

export default function Loading({ loading, children }: LoadingProps) {
  if (loading) {
    return (
      <Spinner fullPage />
    );
  }

  return children;
}
